<!-- <div class="form-group" ngClass="{{settings.layout === 'material' ? 'form-group-material' : ''}}">
	<label for="{{settings.id}}">{{settings.label}}</label>
	<input [(ngModel)]="inputValue" #name="ngModel" name="input" type="{{settings.type ? settings.type : 'text' }}" class="form-control" placeholder="{{(settings.layout !== 'material' && settings.placeholder) ? settings.placeholder : ''}}">
</div> -->
<!-- <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
		<input class="mdl-textfield__input" type="text" id="sample3">
		<label class="mdl-textfield__label" for="sample3">Text...</label>
	  </div> -->

<mat-form-field class="example-full-width">
	<input matInput placeholder="Favorite food" value="Sushi">
</mat-form-field>